import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, trend, loading }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-elevation-2 transition-smooth hover:shadow-elevation-3">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1">
          <p className="text-xs md:text-sm text-muted-foreground mb-1 md:mb-2 font-medium">
            {title}
          </p>
          {loading ? (
            <div className="h-8 md:h-10 bg-muted animate-pulse rounded w-24 md:w-32"></div>
          ) : (
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground data-text">
              {value}
            </h3>
          )}
          {!loading && change ? (
            <p className={`text-xs mt-1 md:mt-1.5 ${getChangeColor()}`}>{change}</p>
          ) : null}
        </div>
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name={icon} size={20} color="var(--color-primary)" className="md:w-6 md:h-6" />
        </div>
      </div>
      {trend && trend?.length > 0 && (
        <div className="mt-3 md:mt-4 h-8 md:h-10 flex items-end gap-0.5 md:gap-1">
          {trend?.map((value, index) => (
            <div
              key={index}
              className="flex-1 bg-primary/20 rounded-t transition-smooth hover:bg-primary/30"
              style={{ height: `${value}%` }}
            ></div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MetricCard;